import {Component} from '@angular/core';
import {Monitor} from '../../../../domain/monitor/monitor';

@Component({
  templateUrl: 'monitor-information.component.html',
  styleUrls: ['./monitor-information.component.scss']
})
export class GridMonitorInformationComponent {
  public monitor: Monitor;

  public agInit(params: any): void {
    this.monitor = params.data;
  }
}
